import React from 'react';
import LocationTemplate from './LocationTemplate';

const CoveCityPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Cove City"
      stateName="North Carolina"
      countyName="Craven"
      zipCodes={["28523"]}
      latitude={35.1872}
      longitude={-77.3193}
      population={399}
      historicalFact="Incorporated in 1887, small town in Craven County."
      nearbyTowns={[
        "New Bern, NC",
        "Dover, NC",
        "Maysville, NC",
        "Pollocksville, NC",
        "Vanceboro, NC",
        "Oriental, NC",
        "Arapahoe, NC",
        "Havelock, NC"
      ]}
    />
  );
};

export default CoveCityPage;